import { ref } from 'vue';
import { isNullOrEmpty, isEmail, isPhoneNumber, isValidatePassword, toCamelCase } from '../composables/utils';
import http from './http'

export default function useUser() {
    const loading = ref(false);
    const sending = ref(false);
    const checkingPhoneNumber = ref(false);
    const checkingEmail = ref(false);
    const timer = ref(0);
    const view = ref('passwordLogin');
    const tab = ref('signin');

    const validateEmailOrPhoneNumber = (rule, value, callback) => {
        if (isNullOrEmpty(value)) {
            callback(new Error('Please enter your email or mobile number'))
        }

        if (!isEmail(value) && !isPhoneNumber(value)) {
            callback(new Error('Please enter a valid email or mobile number'))
        }
    }

    const loginForm = ref({
        account: '',
        password: '',
    });

    const loginFormRef = ref();
    const loginFormRules = {
        account: { required: true, message: 'Please enter your username', trigger: 'blur' },
        password: { required: true, message: 'Please enter your password', trigger: 'blur' },
    };

    const login2faForm = ref({
        account: '',
        token: '',
    });

    const login2faFormRef = ref();
    const login2faFormRules = {
        account: [{ validator: validateEmailOrPhoneNumber, trigger: 'blur' }],
        token: { required: true, message: 'Please enter the code', trigger: 'blur' },
    };

    const registerForm = ref({
        userName: '',
        password: '',
        confirmPassword: '',
        email: '',
        phoneNumber: '',
        nickName: '',
        firstName: '',
        lastName: '',
        captchaId: 0,
        captcha: '',
    });


    const userInfo = window.$core.data?.UserInfo;

    async function validateEmail(rule, value, callback) {

        if (!isEmail(value)) {
            callback(new Error('Please enter a valid email. Ex. youremail@domain.com'))
        } else if (value != userInfo?.email) {
            try {
                //checkingEmail.value = true
                const exists = await http.request('get', '/api/identity/CheckEmailExists', { email: value });
                if (exists) {
                    callback(new Error('This email is already in use'))
                } else {
                    callback();
                }
            } catch (error) {
                console.log(error);
                callback(new Error('Validation failed'));
            } finally {
                //checkingEmail.value = false;
            }
        }
    }

    async function validatePhoneNumber(rule, value, callback) {
        if (!isPhoneNumber(value)) {
            callback(new Error('Please enter a valid  mobile number. Ex. 6475555555'))
        } else if (value != userInfo?.phoneNumber) {
            try {
                //checkingPhoneNumber.value = true;
                const exists = await http.request('get', '/api/identity/CheckPhoneNumberExists', { phoneNumber: value });
                if (exists) {
                    callback(new Error('This phone number is already in use'))
                } else {
                    callback();
                }
            } catch (error) {
                callback(new Error('Validation failed'));
            } finally {
               //checkingPhoneNumber.value = false;
            }
        }
    }

    const validatPassword = (rule, value, callback) => {
        if (!isValidatePassword(value)) {
            callback(new Error('Please enter a valid password'));
        }
    };

    const validateConfirmPassword = (rule, value, callback) => {
        if (value !== registerForm.value.password) {
            callback(new Error('Passwords do not match'));
        } else {
            callback();
        }
    };

    const registerFormRef = ref();
    const registerFormRules = {
        firstName: { required: true, message: 'Please enter your first name', trigger: 'blur' },
        lastName: { required: true, message: 'Please enter your last name', trigger: 'blur' },
        email: [{ validator: validateEmail, trigger: 'blur' }],
        phoneNumber: [{ validator: validatePhoneNumber, trigger: 'blur' }],
        password: [{ validator: validatPassword, trigger: 'blur' }],
        confirmPassword: [{ validator: validateConfirmPassword, trigger: 'blur' }],
        captcha: { required: true, message: 'Please enter the captcha code', trigger: 'blur' },
    };

    const resetPasswordForm = ref({
        account: '',
        token: '',
        password: '',
        confirmPassword: '',
    });

    const validateConfirmPassword2 = (rule, value, callback) => {
        if (value !== resetPasswordForm.value.password) {
            callback(new Error('Passwords do not match'));
        } else {
            callback();
        }
    };

    const resetPasswordFormRef = ref();
    const resetPasswordFormRules = ref({
        account: [{ validator: validateEmailOrPhoneNumber, trigger: 'blur' }],
        token: { required: true, message: 'Please enter the code', trigger: 'blur' },
        password: [{ validator: validatPassword, trigger: 'blur' }],
        confirmPassword: [{ validator: validateConfirmPassword2, trigger: 'blur' }],
    });

    function onLogin() {
 
        loginFormRef.value?.validate(errors => {
            if (!errors) {
                loading.value = true;
                http.request('post', '/api/auth/login', loginForm.value)
                    .then(res => {
                        if (res.Type == 200) {
                            window.$core.setToken(res.Data);
                            http.request('get', '/api/auth/userinfo').then((data) => {
                                console.log('/api/auth/userinfo', data);
                                window.$core.setUserInfo(data);
                                window.$router.push('/MyProfile/0');
                            })
                        }
                       
                    })
                    .finally(() => {
                        loading.value = false;
                    });
            }
        });
    }

    function onLogin2Fa() {
        login2faFormRef.value?.validate(errors => {
            if (!errors) {
                loading.value = true;
                http.request('post', '/api/auth/login2fa', login2faForm.value)
                    .then(res => {
                        window.$core.setToken(res.Data);
                        http.request('get', '/api/auth/userinfo').then((data) => {
                            window.$core.setUserInfo(data);
                            if (view.value == 'preset') {
                                window.$dialog.success({
                                    title: 'Registration Successful',
                                    closable: false,
                                    content: 'Thank you for verifying your email and mobile device.  Enjoy using this website and all its features and services.',
                                    positiveText: 'OK',
                                    onPositiveClick: () => {
                                        window.gtagSendEvent();
                                        window.$router.push('/MyProfile/0');
                                    },
                                })
                            } else {
                                window.$router.push('/MyProfile/0')
                            }

                        })
                    })
                    .finally(() => {
                        loading.value = false;
                    });
            }
        });
    }

    function onOauth2Login(t) {

        const token = JSON.parse(t);
        //const token = toCamelCase(t2);
        if (token?.AccessToken == null) return;

        loading.value = true;

        window.$core.setToken(token);
        http.request('get', '/api/auth/userinfo').then(data => {
            window.$core.setUserInfo(data);
            window.$router.push('/MyProfile/0');
        }).finally(() => {
            loading.value = false;
        });
    }

    function onLogout() {
        loading.value = true;
        http.request('post', '/api/auth/logout')
            .then(() => {
                window.$core.clearStorage();
                window.$router.push('/');
            })
            .finally(() => {
                loading.value = false;
            });
    }

    function onRegister() {
        registerFormRef.value?.validate(errors => {
            if (!errors) {
                loading.value = true;
                registerForm.value.userName = registerForm.value.email;
                registerForm.value.nickName = `${registerForm.value.firstName} ${registerForm.value.lastName}`;
                http.request('post', '/api/identity/register', registerForm.value)
                    .then(res => {
                        if (res?.Type == 200) {
                            //useCookie("phoneNumber").value = registerForm.value.phoneNumber;

                            window.$dialog.success({
                                title: 'Registration Successful',
                                closable: false,
                                content: 'Please click on the link that has just been sent to your email provided. From there you may enter the six digit confirmation code sent to your mobile device via SMS. If you did not receive an Email/SMS within 5 minutes, you may log in with your username and password and a new Email/SMS confirmation will be sent to you.',
                                positiveText: 'OK',
                                onPositiveClick: () => {
                                    tab.value = 'signin';
                                    view.value = 'passwordLogin';
                                },
                            })


                            //clearObjectValues(registerForm.value)
                            registerFormRef.value?.restoreValidation()
                        }
                        else {
                            refreshVerifyCode()
                        }
                    })
                    .finally(() => {
                        loading.value = false;
                    });
            }
        });
    }

    function onResetPassword() {
        resetPasswordFormRef.value?.validate(errors => {
            if (!errors) {
                loading.value = true;
                http.request('post', '/api/identity/ResetPassword2Fa', resetPasswordForm.value)
                    .then(res => {
                        if (res?.Type == 200) {
                            window.$dialog.success({
                                title: 'Password Reset Successful',
                                content: 'You can now log in with your new password.',
                                positiveText: 'OK',
                                closable: false,
                                onPositiveClick: () => {
                                    tab.value = 'signin';
                                    view.value = 'passwordLogin';
                                },
                            })

                            //clearObjectValues(resetPasswordForm.value)
                            resetPasswordFormRef.value?.restoreValidation()
                        }
                    })
                    .finally(() => {
                        loading.value = false;
                    });
            }
        });
    }

    let countdownInterval;
    const startCountdown = () => {
        timer.value = 60;
        countdownInterval = setInterval(() => {
            if (timer.value > 0) {
                timer.value -= 1;
            } else {
                clearInterval(countdownInterval);
            }
        }, 1000);
    }

    function onSend2FA(form) {
        if (timer.value > 0 || isNullOrEmpty(form.account)) return;

        sending.value = true;
        http.request('post', '/api/identity/send2fa', { account: form.account })
            .then(res => {
                if (res?.Type == 200) {
                    startCountdown()
                    if (res?.Content?.includes('Email')) {
                        window.$message.success('Verification code has been sent to your email.')
                    }
                    else if (res?.Content?.includes('SMS')) {
                        window.$message.success('Verification code has been sent to your phone.')
                    }
                    else {
                        window.$message.success(res?.Content)
                    }
                }
                sending.value = false
            })
            .finally(() => {
                sending.value = false;
            });
    }

    function refreshVerifyCode() {
        registerForm.value.captchaId = Math.random();
    
    }

    const isCanadaIp = ref(true);
    function checkIpAddress() {
        http.request('get', '/api/common/iscanadaip')
            .then(res => {
                if (res?.Type == 200) {
                    isCanadaIp.value = res.Data;
                }
            })
            .finally(() => {});
    }

    refreshVerifyCode();

    return {
        sending,
        loading,
        checkingPhoneNumber,
        checkingEmail,
        timer,
        view,
        tab,
        loginForm,
        loginFormRef,
        loginFormRules,
        login2faForm,
        login2faFormRef,
        login2faFormRules,
        registerForm,
        registerFormRef,
        registerFormRules,
        resetPasswordForm,
        resetPasswordFormRef,
        resetPasswordFormRules,
        onLogin,
        onOauth2Login,
        onLogout,
        onRegister,
        onResetPassword,
        onSend2FA,
        onLogin2Fa,
        refreshVerifyCode,
        validatPassword,
        validateEmail,
        validatePhoneNumber,
        validateEmailOrPhoneNumber,
        checkIpAddress,
        isCanadaIp
    };
}
